import { useLocation } from "react-router-dom";
import { useConfig } from "@/components/Layout";
import { trackEvent } from "@/lib/tracking";

export function WhatsAppIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2Z" />
    </svg>
  );
}

export default function WhatsAppButton({ position = "content", compact = false, large = false, className = "" }) {
  const config = useConfig();
  const location = useLocation();
  const label = config?.whatsapp_label || "Jetzt per WhatsApp anfragen";

  if (!config?.whatsapp_e164) return null;

  const prefill = encodeURIComponent(config?.whatsapp_prefill || "Hallo Mabuhay, ich interessiere mich für ein Catering und bitte um ein unverbindliches Angebot.");
  const href = `https://wa.me/${config.whatsapp_e164.replace(/[^0-9]/g, "")}?text=${prefill}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`whatsapp-${position}-button`}
      onClick={() => trackEvent("whatsapp_click", { page: location.pathname, position })}
      className={`inline-flex items-center gap-2 border-2 border-[#25D366] text-[#25D366] font-semibold rounded hover:bg-[#25D366]/10 transition-colors ${
        large ? "px-6 py-4 text-sm" : compact ? "px-3 py-2 min-h-[44px] text-xs" : "px-6 py-4 min-h-[48px] text-sm"
      } ${className}`}
    >
      <WhatsAppIcon className={large ? "w-5 h-5" : "w-4 h-4"} />
      <span>{compact ? "WhatsApp" : label}</span>
    </a>
  );
}
